<template>
  <div class="start">
    <div class="title">
      <img
        class="title-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/aa6dbcba9b92d704a96cb4b8c7f78b96.png"
        alt=""
      />
    </div>
    <div class="btn-container">
      <div class="has" @click="bindCode">我已有定量饭盒，去扫码绑定</div>
      <div class="not" @click="bindGetCup">
        我没有定量饭盒，去购买<span class="iconfont icon-you"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    //去购买饭盒
    bindGetCup() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/goods/detail?id=1426923850155'
        )
      }
    },
    bindRes(url) {
      if (url == location.origin + '/eating-today/register') {
        this.registerWaterUser()
      } else {
        this.$toast('识别的二维码不能跳转')
      }
    },
    registerWaterUser() {
      this.$http
        .postBaseApp('member/todayDiet/registerByQr', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.replace({
              path: '/eating-today/fill-info'
            })
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //去扫码
    async bindCode() {
      if (this.$http._isApp()) {
        let res = await this.$betterwe.onAppScanQRCode().catch(() => {})
        if (res) {
          if (res.code == 0) {
            this.bindRes(res.path)
          } else {
            this.$toast('扫码失败')
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.start {
  width: 100%;
  height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fae9335d5900188f0f0dbb67d3fd0d8f.png');
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  .title {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    width: 100%;
    margin-top: 80px;
    margin-bottom: 24px;
    .title-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.btn-container {
  width: 283px;
  text-align: center;
  margin-bottom: 7.1vh;
  .has {
    height: 42px;
    line-height: 42px;
    background: #6236ff;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 12px;
  }
  .not {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6236ff;
    line-height: 20px;
    .iconfont {
      margin-left: 6px;
    }
  }
}
</style>
